import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';
import { LazyLoadImage } from 'react-lazy-load-image-component';

interface MobileSectionContentProps {
  isExpanded: boolean;
}

export const StyledSection = styled(Section)`
  display: flex;
  width: 100%;
  overflow: visible;
  background: #1c1c1c !important;
  padding: 40px 0px !important;
  margin: 0px !important;

  ${media.md`
    padding: 40px 0px !important;
  `}

  ${media.lg`
    padding: 40px 0px 60px !important;
  `}

  ${media.xl`
    padding: 75px 0px 60px !important;
  `}
`;

export const StyledContentBlock = styled.div`
  width: 100%;
  max-width: 1440px;
  padding: 0px !important;
  margin: auto;
`;

export const MainContainer = styled.div`
  padding: 0px 20px !important;

  ${media.md`
    padding: 0px 60px !important;
  `}

  ${media.xl`
    padding: 0px 80px !important;
  `}
`;

export const MainWrapper = styled.div`
  display: none;

  ${media.lg`
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 100%;
    gap: 50px;
  `}
`;

export const FooterGrid = styled.div`
  display: grid;

  grid-template-columns: repeat(5, 1fr);

  grid-template-areas:
    'download company insights products reviews follow'
    'download company insights products reviews follow'
    'download company insights products reviews follow';
  gap: 80px 40px;
  width: 100%;

  & > div:nth-child(1) {
    grid-area: download;
  }

  & > div:nth-child(2) {
    grid-area: company;
  }

  & > div:nth-child(3) {
    grid-area: insights;
  }

  & > div:nth-child(4) {
    grid-area: products;
  }

  & > div:nth-child(5) {
    grid-area: reviews;
  }

  & > div:nth-child(6) {
    grid-area: follow;
  }

  ${media.xl`
    grid-template-columns: repeat(6, 1fr);
    
    grid-template-areas:
      'download company insights products reviews follow'
      'download company insights products reviews follow';
  `}
`;

export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 24px;
`;

export const ColumnTitle = styled.h3`
  color: #ffffff;
  font-family: 'Satoshi Variable Medium';
  font-size: 20px;
  font-weight: 500;
  line-height: 110%;
  margin: 0px;
`;

export const StoreWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  align-self: stretch;
  width: 100%;
  gap: 10px;
`;

export const GooglePlay = styled.div`
  display: flex;
  height: 50px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid #888a98;
`;

export const GooglePlayImageWrapper = styled.div`
  width: 114.104px;
  height: 26.533px;
  cursor: pointer;
`;

export const AppStore = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid #888a98;
`;

export const AppStoreImageWrapper = styled.div`
  width: 107.008px;
  height: 28.507px;
  cursor: pointer;
`;

export const LinkList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 10px;
`;

export const LinkItem = styled.li`
  margin: 0;
`;

export const StyledLink = styled.a`
  color: #888a98;
  font-family: 'Satoshi Variable Medium';
  font-size: 16px;
  font-weight: 400;
  line-height: 27px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #ffffff;
  }
`;

export const DownWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const LogoContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LogoImage = styled(LazyLoadImage)`
  width: 190px;
  height: 40px;

  ${media.md`
    width: 228px;
    height: auto;
  `}

  ${media.xl`
    width: 238px;
    height: auto;
  `}
`;

export const Copyright = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: 240px;
`;

export const CopyrightText = styled.p`
  color: #888a98;
  font-family: 'Satoshi Variable Medium';
  font-size: 14px;
  font-weight: 400;
  line-height: 109%;
  margin: 0px;
`;

export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 40px;

  ${media.lg`
    display: none;
  `}
`;

export const MobileDownloadSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  gap: 20px;
`;

export const MobileLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const MobileSectionSeparator = styled.span`
  width: 100%;
  border-bottom: 1px solid #888a98;
`;

export const MobileSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 20px 0px;
  border-bottom: 1px solid #888a98;
  cursor: pointer;
`;

export const MobileSectionTitle = styled.h3`
  color: #ffffff;
  font-family: 'Satoshi Variable Medium';
  font-size: 20px;
  font-weight: 500;
  line-height: 110%;
  margin: 0px;
`;

export const ToggleIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ff9500;
`;

export const MobileSectionContent = styled.div<MobileSectionContentProps>`
  display: ${props => (props.isExpanded ? 'block' : 'none')};
  width: 100%;
  padding: 16px 0px;
  border-bottom: 1px solid #888a98;
`;

export const MobileLinkList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 12px;
`;

export const MobileLinkItem = styled.li`
  margin: 0;
`;

export const MobileLink = styled.a`
  color: #888a98;
  font-family: 'Satoshi Variable Medium';
  font-size: 16px;
  font-weight: 400;
  line-height: 27px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #ffffff;
  }
`;

export const MobileFooterBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  gap: 20px;
  padding: 0px 0px 40px;
`;

export const MobileLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MobileCopyright = styled.p`
  width: 230px;
  color: #888a98;
  font-family: 'Satoshi Variable Medium';
  font-size: 14px;
  font-weight: 400;
  line-height: 109%;
  margin: 0;
`;
